import type { ThemeWithoutTokens } from '../theme.types';

// import design tokens that components needs here
import { anchorTokens } from './anchor';
import { avatarTokens } from './avatar';
import { badgeTokens } from './badge';
import { bannerTokens } from './banner';
import { breadcrumbsTokens } from './breadcrumbs';
import { buttonTokens } from './button';
import { calendarMonthTokens } from './calendarMonth';
import { cardTokens } from './card';
import { cellTextSubTokens } from './cellTextSub';
import { chipTokens } from './chip';
import { coloredCardTokens } from './coloredCard';
import { controlTokens } from './control';
import { dateInputTokens } from './dateInput';
import { dividerTokens } from './divider';
import { drawerTokens } from './drawer';
import { dropdownTokens } from './dropdown';
import { fileInputTokens } from './fileInput';
import { filterTokens } from './filter';
import { formLabelTokens } from './formLabel';
import { gridTokens } from './grid';
import { headerNavBarTokens } from './headerNavBar';
import { headerNavIconTokens } from './headerNavIcon';
import { headerNavItemTokens } from './headerNavItem';
import { headerNavSubItemTokens } from './headerNavSubItem';
import { headingTokens } from './heading';
import { highlightedIconTokens } from './highlightedIcon';
import { iconTokens } from './icon';
import { modalTokens } from './modal';
import { overlayTokens } from './overlay';
import { radioTokens } from './radio';
import { selectTokens } from './select';
import { stepperTokens } from './stepper';
import { switchTokens } from './switch';
import { tableTokens } from './table';
import { tabsTokens } from './tabs';
import { tagTokens } from './tag';
import { textTokens } from './text';
import { toastTokens } from './toast';
import { tooltipTokens } from './tooltip';
import { treeTokens } from './tree';
import { typoTokens } from './typo';

// reexport them as global design tokens properties
export const designTokens = (theme: ThemeWithoutTokens) =>
  ({
    ...anchorTokens(theme),
    ...badgeTokens(theme),
    ...breadcrumbsTokens(theme),
    ...buttonTokens(theme),
    ...cardTokens(theme),
    ...cellTextSubTokens(theme),
    ...chipTokens(theme),
    ...controlTokens(theme),
    ...dividerTokens(theme),
    ...dropdownTokens(theme),
    ...fileInputTokens(theme),
    ...formLabelTokens(theme),
    ...gridTokens(theme),
    ...iconTokens(theme),
    ...highlightedIconTokens(theme),
    ...modalTokens(theme),
    ...overlayTokens(theme),
    ...radioTokens(theme),
    ...selectTokens(theme),
    ...tabsTokens(theme),
    ...tagTokens(theme),
    ...treeTokens(theme),
    ...typoTokens(theme),
    ...calendarMonthTokens(theme),
    ...dateInputTokens(theme),
    ...bannerTokens(theme),
    ...toastTokens(theme),
    ...coloredCardTokens(theme),
    ...tooltipTokens(theme),
    ...switchTokens(theme),
    ...headerNavIconTokens(theme),
    ...headerNavItemTokens(theme),
    ...headerNavSubItemTokens(theme),
    ...drawerTokens(theme),
    ...headerNavBarTokens(theme),
    ...avatarTokens(theme),
    ...headingTokens(theme),
    ...textTokens(theme),
    ...stepperTokens(theme),
    ...filterTokens(theme),
    ...tableTokens(theme),
  }) as const;

export type DesignTokens = ReturnType<typeof designTokens>;
